// extracted by mini-css-extract-plugin
export var container = "AddComment-module--container--wGV3j";
export var textarea = "AddComment-module--textarea--CWvxI";
export var title = "AddComment-module--title--fvzDg";